import { render, staticRenderFns } from "./CenterNoticePage.vue?vue&type=template&id=4363d0ae&"
import script from "./CenterNoticePage.vue?vue&type=script&lang=js&"
export * from "./CenterNoticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports